import { render } from "./JimCapitalROI.vue?vue&type=template&id=5216a20c&scoped=true"
import script from "./JimCapitalROI.vue?vue&type=script&lang=js"
export * from "./JimCapitalROI.vue?vue&type=script&lang=js"

import "./JimCapitalROI.vue?vue&type=style&index=0&id=5216a20c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5216a20c"]])

export default __exports__